import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { Box, Checkbox, Divider, Stack } from '@mui/material';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import { TimePicker } from '@mui/x-date-pickers';
import { TableInput } from '../../../../components/common';
import { convToTime } from '../../../../utils/helpers';

interface IProps {
  moduleData: any;
  isView: boolean;
  departmentData: any;
}

const theadData = [
  'Select No.',
  'Machine/Tool/Fixture/Gauge No.',
  'Details of Break Down',
  'B/D Time',
  'Attended',
  'Work Completion',
  'Delete',
];

const THead = ({ moduleData, isView, departmentData }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={12}
        rowSpan={3}
        labels={['Doc No.:', 'Rev No.:', 'Eff. Date:']}
        values={['FM/PROD/10', '01', '01.04.2019']}
        heading="Break Down Slip"
      />
      <tr>
        <th align="left" style={{ minWidth: '150px' }}>
          To:-
          <TableInput
            isView={isView}
            name="to"
            type="text"
            value={moduleData.to}
            onChange={(e) => {
              moduleData.to = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={4}>
          Maintenance Dept :
          <TableInput
            isView={isView}
            name="maint_dept"
            type="text"
            value={moduleData.maint_dept}
            onChange={(e) => {
              moduleData.maint_dept = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={4}>
          Tool Room Dept :
          <TableInput
            isView={isView}
            name="tool_room_dept"
            type="text"
            value={moduleData.tool_room_dept}
            onChange={(e) => {
              moduleData.tool_room_dept = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th align="left" colSpan={3}>
          Date :
          {isView ? (
            formatDate(moduleData.module_date)
          ) : (
            <DatePickerMui
              value={moment(moduleData.moduleData_Date || null)}
              onChange={(date) => {
                moduleData.moduleData_Date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={5}>
          From (Dept) :
          {isView ? (
            moduleData?.department_id?.department_name
          ) : (
            <AutocompleteMuiCustom
              id="Department"
              label=""
              option_name="department_name"
              key={'departments'}
              arrayofObj={departmentData}
              value={moduleData?.department_id || ''}
              onChange={(e, value) => {
                moduleData.department_id = value;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th align="left" colSpan={4}></th>
        <th align="left" colSpan={3}>
          Time :
          {isView ? (
            convToTime(moduleData?.module_time)
          ) : (
            <TimePicker
              value={moment(moduleData?.module_time || '')}
              onChange={(date) => {
                moduleData.module_time = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        {theadData.map((heading, index) => (
          <th
            key={heading + index}
            rowSpan={index <= 3 ? 2 : 1}
            colSpan={index == 4 ? 3 : index == 5 ? 4 : 1}
          >
            {heading}
          </th>
        ))}
      </tr>
      <tr>
        <th>By</th>
        <th>Date</th>
        <th>Time</th>
        <th>Date</th>
        <th>Time</th>
        <th>Status</th>
        <th>Verified by (Complience)</th>
      </tr>
    </thead>
  );
};

export default THead;
